import React from 'react';
import useIntls from '@opm/hooks/useIntls';
import VideoCard from '@opm/pages/Videos/components/videoCard';
import './index.scss';

interface IRelatedVideosProps {
  videos: any[];
  maxCount?: number;
  className?: string;
}

export default function RelatedVideos(props: IRelatedVideosProps) {
  const { videos = [], maxCount = 4, className } = props;
  const { intl } = useIntls();

  const list = videos.slice(0, maxCount);
  if (list.length === 0) return null;

  return (
    <div className={`dbom-related-videos ${className || ''}`}>
      <div className="dbom-related-videos-title">{intl('Related Videos')}</div>
      <div className="dbom-related-videos-list">
        {list.map((video: any, idx: number) => (
          <div key={idx} className="dbom-related-videos-item">
            <VideoCard
              item={{
                ...video,
                username: video.author_name || video.username,
                channel: 'tiktok',
                video_title: video.title,
              }}
              hideKeys={['comments', 'duration', 'likes']}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
